import { useQuery } from '@tanstack/react-query';

import { messageApi } from '@/api';

/**
 * The unread count beside the Messages nav item.
 *
 * It has a poll as well as the socket, and the interval is long on purpose:
 * the socket invalidates this query the moment a message arrives, so the poll
 * is only there to correct a badge that a dropped connection left stale.
 */
export function UnreadBadge() {
  const { data } = useQuery({
    queryKey: ['messages-unread'],
    queryFn: messageApi.getUnreadMessages,
    refetchInterval: 120_000,
  });

  const unread = data?.unread ?? 0;
  if (!unread) return null;

  return (
    <span
      className="bg-brand-600 ml-2 inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-xs font-medium text-white"
      aria-label={`${unread} unread`}
    >
      {unread > 99 ? '99+' : unread}
    </span>
  );
}
